import { enableProdMode, ApplicationRef } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { devTools } from '@ngneat/elf-devtools';

if (environment.production) {
  enableProdMode();
}

// Local dev: actively unregister any service worker the browser still holds
// from a previous build. The ServiceWorkerModule.register call in app.module
// is already gated on environment.production, but a SW once registered persists
// in the browser per origin until explicitly removed — manual "Unregister" in
// DevTools is unreliable when the user has multiple tabs / forgets a step,
// so we do it programmatically every dev boot. No-op once unregistered.
if (!environment.production && 'serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((regs) => {
    regs.forEach((reg) => {
      reg.unregister().then((ok) => {
        if (ok) console.warn('[dev] Unregistered stale service worker:', reg.scope);
      });
    });
  }).catch(() => {});
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then((moduleRef) => {
    if ('serviceWorker' in navigator && environment.production) {
      navigator.serviceWorker.register('ngsw-worker.js');
    }
    devTools({
      postTimelineUpdate: () => moduleRef.injector.get(ApplicationRef).tick(),
    });
  })
  .catch((err) => console.log(err));
